/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentEventSeverities } from './equipment-event-severities';


export interface DeviceFaultResponse { 
    code: string;
    severity: EquipmentEventSeverities;
    vendorCode?: string | null;
    vendorMessage?: string | null;
    slot?: number | null;
    chip?: number | null;
    pool?: number | null;
    source?: string | null;
    suppressed: boolean;
    suppressionReason?: string | null;
}



